import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { DeferActionsMedia } from './DeferActionsMedia';
import { DeferActionsRuntime } from './DeferActionsRuntime';
export class DeferActions extends ActionRegistryCategory {
    label = 'Defer';
    constructor(parent) {
        super(parent);
    }
    c_media = new DeferActionsMedia(this);
    c_runtime = new DeferActionsRuntime(this);
}
